
	import DateRangePicker from 'vue2-daterange-picker'

	export default {
		components: {
			DateRangePicker
		},
		data () {
			return {
				loading: true,
				dateRange: {
					startDate: null,
					endDate: null
				},
				employeeShifts: [],
				selectedEmployeeShift: null,
				employees: [],
				employeeId: null,
				salesReport: {},
				topItemBySales: {},
				brandSalesReport: {},
				consolidatedShift: false,
				consolidatedShiftDownload: false,
				consolidatedShifts: [],
				selectedConsolidatedShifts: []
			}
		},
		computed: {
			bridgeName () {
				return this.$store.state.bridgeName
			},
			locale () {
				return this.$store.state.locale
			},
			deviceId () {
				return this.$store.state.deviceId
			},
			locationId () {
				return this.$store.state.locationId
			},
			appVersionNumber () {
				return this.$store.getters.appVersionNumber
			},
			merchant () {
				return this.$store.state.selectedMerchant || this.$store.state.merchant
			},
			employee () {
				return this.$store.state.employee
			},
			employeePolicy () {
				return this.$store.getters.employeePolicy
			},
			employeeShift () {
				return this.$store.state.employeeShift
			},
			settings () {
				return this.$store.state.settings
			},
			paymentMethodSales () {
				return this.salesReport.paymentMethodSales || this.salesReport.paymentMethods
			},
			taxSales () {
				return this.salesReport.tax || this.salesReport.taxes
			},
			tipSales () {
				return this.salesReport.tip || this.salesReport.tips
			},
			channelSales () {
				return this.salesReport.channelSales || this.salesReport.channels
			},
			employeeSales () {
				return this.salesReport.employeeSales || this.salesReport.employees
			},
			creditSales () {
				return this.salesReport.creditSales || this.salesReport.credits
			},
			isPrimaryDevice () {
				return this.$store.state.device.is_primary
			},
			shiftSelectionModals: {
				get () {
					return this.selectedConsolidatedShifts.length === this.consolidatedShifts.length
				},
				set (value) {
					this.selectedConsolidatedShifts = value ? this.consolidatedShifts.map(d => d.id) : []
				}
			}
		},
		watch: {
			selectedEmployeeShift () {
				this.getReports()
			}
		},
		async beforeMount () {
			let employees = await this.$bridge.getEmployees(this.deviceId, this.locationId, this.objToJson({
				type: ['admin', 'staff'],
				offset: -1
			}))

			employees = (typeof employees === 'string' ? JSON.parse(employees) : employees)
			this.employees = employees.data || employees
			this.employeeShifts = [{ ...this.employeeShift }]
			let employeeShiftIds = await this.$store.dispatch('bridgeCall', {
				methodName: 'getLocalStorage',
				args: ['consolidatedEmployeeShiftIds']
			}) || []

			employeeShiftIds = (typeof employeeShiftIds === 'string' ? JSON.parse(employeeShiftIds) : employeeShiftIds)
			this.consolidatedShift = this.settings.general.show_consolidate_shift_summary && (Array.isArray(employeeShiftIds) && employeeShiftIds.length > 1 && this.settings.general.enable_token_number_system && this.isPrimaryDevice && this.appVersionNumber >= 4133)
			this.selectedEmployeeShift = { ...this.employeeShift }

			if (this.settings.general.show_shiftwise_summary) {
				this.getConsolidatedShifts()
			}
		},
		methods: {
			consolidatedShiftSummaryPrintAndDownload (type) {
				if (type === 'download') {
					this.consolidatedShiftDownload = true
				}

				this.selectedConsolidatedShifts = []
				this.$refs.shiftSelectionModal.show()
			},
			async getConsolidatedShifts () {
				const businessHours = this.$store.state.merchant.customAttributes.business_hours

				const time = this.getBusinessDayRange(
					businessHours?.opening
				)
				const consolidatedShift = await this.$store.dispatch('bridgeCall', {
					methodName: 'getEmployeeShifts',
					args: [
						this.deviceId,
						this.objToJson({
							device_id: this.deviceId,
							from_date: businessHours?.opening ? time.start : this.$moment().startOf('day').toDate(),
							to_date: businessHours?.closing ? time.end : this.$moment().endOf('day').toDate()
						})
					]
				})

				this.consolidatedShifts = consolidatedShift
			},
			getBusinessDayRange (
				opening
			) {
				const now = this.$moment()
				const today = this.$moment().startOf('day')

				let openHour = parseInt(opening.split(':')[0], 10)
				const openMinute = parseInt(opening.split(':')[1], 10)
				const isOpenPM = opening.toLowerCase().includes('pm')

				if (isOpenPM && openHour < 12) {
					openHour += 12
				}

				if (!isOpenPM && openHour === 12) {
					openHour = 0
				}

				let openingTime = today.clone().add(openHour, 'hours').add(openMinute, 'minutes')

				if (now.isBefore(openingTime)) {
					openingTime = openingTime.subtract(1, 'days')
				}

				const closingTime = openingTime.clone().add(1, 'days')

				return {
					start: openingTime.utc().toISOString(),
					end: closingTime.utc().toISOString()
				}
			},
			async getEmployeeShifts () {
				const employeeShifts = await this.$store.dispatch('bridgeCall', {
					methodName: 'getEmployeeShifts',
					args: [this.deviceId, this.objToJson({
						device_id: this.deviceId,
						from_date: this.$moment(this.dateRange.startDate).startOf('day').toDate(),
						to_date: this.$moment(this.dateRange.endDate).endOf('day').toDate()
					})]
				})

				this.employeeShifts = typeof employeeShifts === 'string' ? JSON.parse(employeeShifts) : employeeShifts
				this.selectedEmployeeShift = this.employeeShifts[0]
			},
			async getReports () {
				this.loading = true

				let itemsSalesReport = await this.$store.dispatch('bridgeCall', {
					methodName: 'getItemsSalesReport',
					args: [
						this.bridgeName === 'ANDROID'
							? this.objToJson(this.merchant.id)
							: this.merchant.id, this.deviceId, (this.appVersionNumber > 3821 && +this.settings.general.multi_employee_kiosk && this.employeePolicy.isAdmin
							? (this.employeeId || null)
							: this.employee.id), this.selectedEmployeeShift?.id || ''
					]
				})
				const salesReport = await this.$store.dispatch('bridgeCall', {
					methodName: 'getSalesReport',
					args: [
						this.bridgeName === 'ANDROID'
							? this.objToJson(this.merchant.id)
							: this.merchant.id, this.deviceId, (this.appVersionNumber > 3821 && +this.settings.general.multi_employee_kiosk && this.employeePolicy.isAdmin
							? (this.employeeId || null)
							: this.employee.id), this.selectedEmployeeShift?.id || ''
					]
				})

				if (salesReport && itemsSalesReport) {
					itemsSalesReport = typeof itemsSalesReport === 'string' ? JSON.parse(itemsSalesReport) : itemsSalesReport
					this.brandSalesReport = itemsSalesReport.brands
					itemsSalesReport = itemsSalesReport.length ? itemsSalesReport : itemsSalesReport.sales
					this.topItemBySales = itemsSalesReport.sort((a, b) => b.quantity - a.quantity)[0] || {}
					this.salesReport = typeof salesReport === 'string' ? JSON.parse(salesReport) : salesReport
					this.loading = false

					if (
						this.settings.general?.show_orders_from_other_devices &&
						this.settings.general.enable_token_number_system
					) {
						const orderFilter = { offset: -1, platform: 'advance' }

						if (!this.settings.general?.show_orders_from_other_devices) {
							orderFilter.employee_shift_id = this.selectedEmployeeShift?.id || ''
						}

						let draftOrders = await this.$store.dispatch('bridgeCall', {
							methodName: 'getOrders',
							args: [this.deviceId, this.objToJson(orderFilter)]
						})

						draftOrders = (typeof draftOrders === 'string' ? JSON.parse(draftOrders) : draftOrders)?.data || []
						const advanceDraftOrders = draftOrders.filter(o => o?.custom_attributes?.platform === 'advance')

						if (advanceDraftOrders.length) {
							const employeeShiftId = this.selectedEmployeeShift?.id || ''
							const salesReport = this.salesReport

							salesReport.advanceOrders = { count: 0, total: 0, data: {} }

							let advancedSplitPaymentMethod = salesReport.advanceOrders.advancedSplitPaymentMethodData
								? { ...salesReport.advanceOrders.advancedSplitPaymentMethodData }
								: null

							for await (const order of advanceDraftOrders) {
								let payments = order.order_payments

								if (!Array.isArray(payments) || !payments.length) {
									const paymentRows = await this.$store.dispatch('bridgeCall', {
										methodName: 'getData',
										args: ['OrderPaymentMethod', `order_id = "${order.id}"`]
									})

									payments = (typeof paymentRows === 'string' ? JSON.parse(paymentRows) : paymentRows)?.data || []
								}

								let paymentsInCurrentShift = []

								if (Array.isArray(employeeShiftId) && employeeShiftId?.length > 0) {
									paymentsInCurrentShift = payments.filter(
										pm => employeeShiftId.includes(pm.employee_shift_id)
									)
								} else {
									paymentsInCurrentShift = payments.filter(
										pm => pm.employee_shift_id === employeeShiftId
									)
								}

								const pmSlug = order.payment_method?.slug || order?.payment_method?.method
								const pmName = order.payment_method?.name || pmSlug

								let countedSplitOrder = false

								for await (const pm of paymentsInCurrentShift) {
									if (pm.slug === 'credit') { continue }

									if (pmSlug === 'split') {
										if (!countedSplitOrder) {
											if (!advancedSplitPaymentMethod) {
												advancedSplitPaymentMethod = {
													name: pmName,
													count: 1,
													total: 0,
													slug: pmSlug,
													splitSubPayments: {}
												}
											} else {
												advancedSplitPaymentMethod.count += 1
											}

											countedSplitOrder = true
										}

										advancedSplitPaymentMethod.total += pm.amount

										if (advancedSplitPaymentMethod.splitSubPayments[pm.slug]) {
											advancedSplitPaymentMethod.splitSubPayments[pm.slug].count += 1
											advancedSplitPaymentMethod.splitSubPayments[pm.slug].total += pm.amount
										} else {
											advancedSplitPaymentMethod.splitSubPayments[pm.slug] = {
												name: pm.name,
												count: 1,
												total: pm.amount
											}
										}
									} else if (salesReport.advanceOrders.data[pmSlug]) {
										salesReport.advanceOrders.data[pmSlug].count += 1
										salesReport.advanceOrders.data[pmSlug].total += pm.amount
									} else {
										salesReport.advanceOrders.data[pmSlug] = {
											name: pmName,
											count: 1,
											total: pm.amount
										}
									}

									salesReport.advanceOrders.count += 1
									salesReport.advanceOrders.total += pm.amount
								}
							}

							if (advancedSplitPaymentMethod) {
								salesReport.advanceOrders.advancedSplitPaymentMethodData = {
									...advancedSplitPaymentMethod
								}
							}

							this.salesReport = { ...salesReport }
						}
					}
				} else {
					this.store.dispatch('checkPrimaryDevice')
				}
			},
			printShift (type) {
				window.printShift({
					type,
					source: 'reports',
					employeeId: this.employeeId,
					employeeShift: (this.settings.general.show_shiftwise_summary && this.selectedConsolidatedShifts?.length) ? this.selectedConsolidatedShifts : this.selectedEmployeeShift
				})

				if (this.settings.general.show_shiftwise_summary) {
					this.$refs.shiftSelectionModal.hide()
					this.consolidatedShiftDownload = false
					this.selectedConsolidatedShifts = []
				}
			},
			clearDateRange () {
				this.dateRange = { startDate: null, endDate: null }
				this.employeeShifts = [{ ...this.employeeShift }]
				this.selectedEmployeeShift = { ...this.employeeShift }
			}
		}
	}
